
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { resolveProgressItems } from '../../../../operations/progress/resolveProgressItems';
import { makeObject } from '../../../../utilities/objects';
import { Action } from '../../../action/Action';
import { getOverallSimpleProgressBreakdown } from '../../../../operations/progress';
import { withSelectedItems } from '../../../decorators/selectors';
import { ConflictResolution } from '../../../../facets/ProgressFacets';

export interface IRetryProgressActionProps {
  itemKeys: string[];
  conflictResolution: ConflictResolution;
}

export class ItemResolveProgressAction extends React.PureComponent<IRetryProgressActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys,
      conflictResolution
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          const eligibleItemKeys = itemKeys.filter((itemKey: string) => {
            const { phase } = getOverallSimpleProgressBreakdown(itemCache, { itemKey });

            return phase === 'failed';
          });

          const onExecute = async () => {
            dispatch(resolveProgressItems({
              items: makeObject(eligibleItemKeys, () => ({
                conflictResolution
              }))
            }));
          };

          return (
            <Action onExecute={ onExecute } isAvailable={ eligibleItemKeys.length > 0 } />
          );
        } }
      </WithItemCache>
    );
  }
}

export const ResolveProgressAction = withSelectedItems()(ItemResolveProgressAction);
